import { Component, OnInit, EventEmitter } from '@angular/core';
import { Utils, SortHeader } from '../../util';
import { MaterializeAction, toast } from 'angular2-materialize';
import { CustomerBillData, CustomerBillService, CustomerBillId } from '../../services/customer-bill.service';
import { CompanyService } from '../../services/company.service';
import { EmployeeId } from '../../services/employee.service';
import { IncomedBill, IncomeData } from '../../services/income.service';
import { Globals } from '../../globals';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

interface Odp {name: string, sd: string};

@Component({
  selector: 'app-bill-report-detail',
  templateUrl: './bill-report-detail.component.html',
  styleUrls: ['./bill-report-detail.component.css']
})
export class BillReportDetailComponent implements OnInit {
  allowed: boolean = false;
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};
  readyToShow: boolean = false;

  companyName: string = '';

  bills: CustomerBillId[] = [];

  rows: any[] = [];
  filteredRows: any[] = [];

  initial: string = '';
  final: string = Utils.today;
  fiscal: string = 'Todo';
  emp: string = 'Todo';
  get showInitials(): boolean { return JSON.parse(this.ls.billrd_shi || 'false') };
  get showSd(): boolean { return JSON.parse(this.ls.billrd_shsd || 'false') };

  fiscalSelect: string[];
  fiscalSelectOpen: boolean = false;
  empSelect: string[];
  empSelectOpen: boolean = false;
  currencySelect: any[];
  currency: string[] = this.ls.s__bill_rep_cur ? JSON.parse(this.ls.s__bill_rep_cur) : ['key0'];
  statusSelect: any[];
  status: string[] = JSON.parse(this.ls.s__bill_rep_stat || "[\"key0\"]");
  converts: any = {};
  
  pickadateParams = Utils.pickadateParams();

  get ls(){ return localStorage };
  get Utils(){ return Utils };
  constructor(
    private service: CustomerBillService,
    private data: CustomerBillData,
    private incomeData: IncomeData,
    private companyService: CompanyService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        if(!this.permission || !this.permission.billReportDetail){
          toast('No tiene permisos.', 3000);
          this.router.navigate(['/']);
        }
        else this.allowed = true;
    });
    let {currencySelect: CS, status: S} = this.data;

    this.currencySelect = Object.keys(CS).map(key => {
      this.converts[key] = CS[key].code;
      this.converts[CS[key].code] = key;
      return {value: key, name: CS[key].code}
    });

    this.statusSelect = Utils.array(S).map(([name, value]) => ({value, name}));
    
    let sub = this.companyService.getCompany().subscribe(({name}) => {sub.unsubscribe(); this.companyName = name});

    /* let a = [
      {name: 'a', age: 7},
      {name: 'a', age: 6},
      {name: 'b', age: 5},
      {name: 'e', age: 4},
      {name: 'd', age: 3},
      {name: 'e', age: 2},
      {name: 'f', age: 1},
    ];
    console.log(Utils.sort(a, [{key: 'name'},{key: 'age', desc: true}]))
    console.log(Utils.sort(a, [{key: 'name'},{key: 'age', desc: false}]))
    console.log(Utils.sort(a, [{key: 'age', desc: true},{key: 'name'}]))
    console.log(Utils.sort(a, [{key: 'age', desc: false},{key: 'name'}])) */
  }

  ngOnInit(){
  }

  getBills(){
    this.readyToShow = false;
    let onEmpty = () => { toast('No hay facturas.', 2000); };
    let obs = this.reportSource == 'bill' ? this.service.getCustomerBills({receptionDate: this.initial, onEmpty}) : this.service.getCustomerBills({minCnLength: 1, onEmpty});
    let sub = obs.subscribe((bills: CustomerBillId[]) => {
      sub.unsubscribe();
      this.bills = bills.filter(bill => bill.active);
      console.log(23, bills);
      this.processBills();
    });
  }
  processBills(){
    this.readyToShow = false;
    if(!this.bills) return toast('Error', 2000);
    if(this.status.includes('selectAll')){
      if(this.status.length > this.statusSelect.length) this.status = [];
      else this.status = this.statusSelect.map(({value}) => value);
    }
    this.chooseSource();
  }

  reportSource: 'bill' | 'ndc' = 'bill';
  chooseSource(){
    this.fiscal = 'Todo';
    this.fiscalSelect = undefined;
    this.emp = 'Todo';
    this.empSelect = undefined;
    if(this.reportSource == 'bill'){
      console.log('Doing for Bill');
      this.ls.s__bill_rep_cur = JSON.stringify(this.currency);
      this.ls.s__bill_rep_stat = JSON.stringify(this.status);
      let def = this.currency.reduce((acc, cur) => ({...acc, [`subTotal${cur}`]: 0, [`ivaTotal${cur}`]: 0, [`total${cur}`]: 0}), {});
      let obj = this.bills.filter(({date, status='key0', cfdi:{currency='key0'}={}}) => 
        date <= this.final &&
        this.currency.includes(currency) &&
        this.status.includes(status)
      ).reduce((acc, {cfdi:{currency='key0'}={}, employeeObj={}, productionOrderObj:[{name='', shortDescription: sd=''}={}]=[], status='key0', uuid='N.A.', date, receptionDate, payDate, folio, ...cur}) => {
        if(folio == 21350) console.log(231, cur);
        let fiscalName = cur.fiscalDataObj.businessName;
        let {name:eName='', lastName=''} = <EmployeeId>employeeObj;
        let residue = new IncomedBill(<CustomerBillId>{date, folio, ...cur}).residue;
        let statusName: string = Globals.BILL_STATUS[status] || '';
        let discountAmount: number = +(cur.totals.amountNoDisc - cur.totals.subtotal).toFixed(2);
        if(!acc[cur.id]){
          acc[cur.id] = {
            folio, odp: <Odp>{name, sd}, fiscal: fiscalName, date, receptionDate, payDate, statusName, uuid, emp: `${eName} ${lastName}`
            , empi: Utils.initials(`${eName} ${lastName}`), discountAmount, ...def, residue, cns: [], ins: []
          };
  
          Object.defineProperty(acc[cur.id].cns, 'totals',{ get: function totals() {
            return this.reduce((acc, cur) => Utils.arraySum(acc, [cur.subtotal, cur.iva, cur.total]), [0,0,0]);
          } });
          Object.defineProperty(acc[cur.id].ins, 'total',{ get: function total() { return this.reduce((acc, {amount}) => acc + amount, 0);} });
        }
        acc[cur.id][`subTotal${currency}`] += cur.totals.subtotal;
        acc[cur.id][`ivaTotal${currency}`] += cur.totals.iva;
        acc[cur.id][`total${currency}`] += cur.totals.total;
        acc[cur.id].cns.push(...cur.creditNotes.map(c => ({currency, ...c}) ));
        cur.incomeds.map(({incomeRef}) => {
          let sub = this.service.afh.docWithIds$(incomeRef.path).subscribe(({amount, date, payMethod='999'}) => {
            sub.unsubscribe();
            acc[cur.id].ins.push({amount, date, payMethod: this.incomeData.statusObjects[payMethod], currency, total: amount});
          })
        })
        //console.log(fiscalName, acc[cur.id].bills);
        return acc;
      }, {});
      let fiscals = new Set(Utils.array(obj).map(([{fiscal}]) => fiscal));
      let emps = new Set(Utils.array(obj).map(([{emp}]) => emp));
      this.fiscalSelect = ['Todo', ...fiscals];
      this.empSelect = ['Todo', ...emps];
      this.rows = Utils.array(obj).reduce((acc, [cur]) => [ cur, ...acc ], [] );
      console.log(34, this.rows);
      this.filterRows();
    }
    if(this.reportSource == 'ndc'){
      console.log('Doing for Ndc');
      this.ls.s__bill_rep_cur = JSON.stringify(this.currency);
      this.ls.s__bill_rep_stat = JSON.stringify(this.status);
      let def = this.currency.reduce((acc, cur) => ({...acc, [`subTotal${cur}`]: 0, [`ivaTotal${cur}`]: 0, [`total${cur}`]: 0}), {});
      let obj = this.bills.filter(({date, status='key0', cfdi:{currency='key0'}={}}) => 
        //date <= this.final &&
        this.currency.includes(currency) &&
        this.status.includes(status)
      ).reduce((acc, {cfdi:{currency='key0'}={}, employeeObj={}, productionOrderObj:[{name='', shortDescription: sd=''}={}]=[], status='key0', uuid='N.A.', date, receptionDate, payDate, folio, ...cur}) => {
        let fiscalName = cur.fiscalDataObj.businessName;
        let {name:eName='', lastName=''} = <EmployeeId>employeeObj;
        let residue = new IncomedBill(<CustomerBillId>{date, folio, ...cur}).residue;
        let statusName: string = Globals.BILL_STATUS[status] || '';

        console.log(666, cur.id, cur.creditNotes);
        let cns = cur.creditNotes.filter(cn => cn.date >= this.initial && cn.date <= this.final);
        for(let ndc of cns){
          let uniqueId = `bill${cur.id}_ndc${ndc.folio}`;
          if(!acc[uniqueId]){
            acc[uniqueId] = {
              folio: `F${folio}-NC${ndc.folio}`, odp: <Odp>{name, sd}, fiscal: fiscalName, date: ndc.date, receptionDate, payDate, statusName, uuid, emp: `${eName} ${lastName}`
              , empi: Utils.initials(`${eName} ${lastName}`), discountAmount: 0, ...def, residue, cns: [], ins: []
            };
    
            Object.defineProperty(acc[uniqueId].cns, 'totals',{ get: function totals() {
              return this.reduce((acc, cur) => Utils.arraySum(acc, [cur.subtotal, cur.iva, cur.total]), [0,0,0]);
            } });
            Object.defineProperty(acc[uniqueId].ins, 'total',{ get: function total() { return this.reduce((acc, {amount}) => acc + amount, 0);} });
          }

          acc[uniqueId][`subTotal${currency}`] += ndc.subtotal;
          acc[uniqueId][`ivaTotal${currency}`] += ndc.iva;
          acc[uniqueId][`total${currency}`] += ndc.total;
          acc[uniqueId].cns.push(...cns.map(c => ({currency, ...c}) ));
        }
        cur.incomeds.map(({incomeRef}) => {
          let sub = this.service.afh.docWithIds$(incomeRef.path).subscribe(({amount, date, payMethod='999'}) => {
            sub.unsubscribe();
            for(let ndc of cns) acc[`bill${cur.id}_ndc${ndc.folio}`].ins.push({amount, date, payMethod: this.incomeData.statusObjects[payMethod], currency, total: amount});
          })
        })
        //console.log(fiscalName, acc[`bill${cur.id}_ndc${ndc.folio}`].bills);
        return acc;
      }, {});
      let fiscals = new Set(Utils.array(obj).map(([{fiscal}]) => fiscal));
      let emps = new Set(Utils.array(obj).map(([{emp}]) => emp));
      this.fiscalSelect = ['Todo', ...fiscals];
      this.empSelect = ['Todo', ...emps];
      console.log('New fiscal select: ', this.fiscalSelect);
      console.log('New emp select: ', this.empSelect);
      this.rows = Utils.array(obj).reduce((acc, [cur]) => [ cur, ...acc ], [] );
      this.filterRows();
    }
    this.readyToShow = true;
    console.log('New fiscal select: ', this.fiscalSelect);
    console.log('New emp select: ', this.empSelect);
    console.log('Process done.');
  }

  filterRows(){
    this.filteredRows = this.rows.filter(({fiscal, emp}) => (fiscal == this.fiscal || this.fiscal=='Todo') && (emp == this.emp || this.emp=='Todo'));
    console.log(45, this.filteredRows)
    console.log('Filtered rows.');
    this.sort();
  }
  /////////////////////////////////////////////////////////////////////////Sort
  sorting: SortHeader;
  sort(key: string = null){
    this.sorting = key ? {key, desc: !this.sorting.desc} : {key: 'folio', desc: true}
    this.filteredRows = Utils.sort(this.filteredRows, [this.sorting]);
    console.log(56, this.filteredRows)
    console.log('Sorted rows.');
  }
  /////////////////////////////////////////////////////////////////////////Sort
  get totals(){
    let def = this.currency.reduce((acc, cur) => ({...acc, [`subTotal${cur}`]: 0, [`ivaTotal${cur}`]: 0, [`total${cur}`]: 0}), {residue: 0});
    return this.filteredRows.reduce((acc, cur) => Utils.objSum(acc, cur), def);
  }

  onCSV(){
    let ets = [`Subtotal`, `IVA`, `Total`];
    let {fiscal, bills, residue, ...totals} = this.totals;
    let rows = [
      {l1: `${this.companyName} - Reporte detallado - ${this.initial.replace(/-/g, '/')} al ${this.final.replace(/-/g, '/')}`},
      {l1: ''},
      {l0: 'Folio', l1: 'OdP', l2: 'Razón social', l3: 'Fecha', l31: 'FRev', l32: 'FPago', l4: 'Estatus', l5: 'UUID', l6: 'Vendedor', l7: 'Descuento', ...this.currency.reduce((acc, cur, i) => ({...acc, ...ets.reduce((acc2, cur2) => ({...acc2, [`${cur2}${cur}`]: `${cur2} ${this.converts[cur]}` }) , {}) }), {}), ll: 'Cuentas por cobrar', ll2: 'Pagos' },
      ...this.filteredRows.map(({cns, ins, empi, ...row}) => ({
        ...row,
        ll: [...cns, ...ins].map(({total:t, currency:c, date:d, payMethod}, i) =>
          `(${i < cns.length ? 'NdC' : `Ing-${payMethod.short}`}-${Utils.money(t)}-${this.data.currencySelect[c].code}-${d.split('-').reverse().join('/')})`
        ).join(',')
      }) ).map(row => {row.odp = this.showSd ? `${row.odp.name} ${row.odp.sd}` : row.odp.name; return row}),
      {l1: ''},
      {l: '', l2: '', l3: '', l31: '', l32: '', l4: '', l41: '', l42: '', l43: '', l5: 'Total:', ...totals, residue}
    ]
    //console.log(rows);
    Utils.downloadExcel(rows, `ReporteDetallado${this.initial}a${this.final}`.replace(/-/g, ''));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  currentShowIndex: number = -1;

  openModalShow(index: number) {
    this.currentShowIndex = index;
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
}
